/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-08-25 14:06:25
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-08 18:32:35
 */
import Vue from 'vue';
import App from './App.vue';
import store from './store';
import ElementUI from 'element-ui';
import '@/styles/theme/index.css'; //自定义主题
import '@/styles/theme/custom.css'; //自定义主题
import '@/components/index';
import '@/font/iconfont.css'; // iconfont
import '@/font/iconfont.js'; // iconfont
import '@/font/font.css'; // 字体
import * as echarts from 'echarts';
import * as filters from './filters';
import Bus from '@/utils/bus.js';
import '@/utils/timer.js';
import router from './router';
import { DICT_TYPE, getDictDatas, getDictDatas2 } from '@/utils/dict';
import plugins from './plugins'; // plugins
import directions from '@/direction';
import '@rd/rd-ui/lib/theme-blue.css';
import '@rd/rd-third';
import horizontalScroll from 'el-table-horizontal-scroll';

window.Vue = Vue;
Vue.prototype.$echarts = echarts;
// 全局方法挂载
Vue.prototype.getDictDatas = getDictDatas;
Vue.prototype.getDictDatas2 = getDictDatas2;
Vue.prototype.DICT_TYPE = DICT_TYPE;
Vue.prototype.$Bus = Bus;
Vue.prototype.$backTop = _ => {
	setTimeout(_ => {
		const main = document.querySelector('main.el-main');
		main.scrollTop = 0;
	});
};

Vue.prototype.isSelf = userId => {
	return `${userId}` === `${store.state.vuex_userId}`;
};

const nanoid = require('nanoid');

Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
// Vue.use(elTableSticky);
Vue.use(horizontalScroll);
Vue.config.productionTip = false;

window._czc = window._czc || [];
window._czc.push(['_setCustomVar', '是否登录授权', '未登录', 86400]);
window._czc.push(['_setCustomVar', '用户角色', '商家', '-1']);

Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key]);
});

const dirNames = Object.keys(directions);
dirNames.forEach(element => {
	Vue.directive(element, directions[element]);
});

//项目启动检测本地cookie是否有di,没有的话，生成并且存入
function checkLocalDi() {
	if (!CookiesTools.getDi()) {
		let di = nanoid.nanoid(32);
		CookiesTools.setDi(di);
	}
}
checkLocalDi();
// 设置全局插件
Vue.use(plugins);
new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app');
